import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { fmt } from "../../lib/api";
import SectionCard from "./SectionCard";

export default function Kategori1({ factors, data, setData, results }) {
  const setNumber = (group, id, v) => {
    setData((d) => ({ ...d, [group]: { ...(d[group] || {}), [id]: v } }));
  };
  const setKacakKg = (id, v) => {
    setData((d) => ({
      ...d,
      kacak: { ...(d.kacak || {}), [id]: { ...(d.kacak?.[id] || {}), kg: v } },
    }));
  };
  const setKacakLabel = (id, v) => {
    setData((d) => ({
      ...d,
      kacak: { ...(d.kacak || {}), [id]: { ...(d.kacak?.[id] || {}), custom_label: v } },
    }));
  };

  return (
    <div className="space-y-6 animate-fadeInUp">
      <div className="mb-2">
        <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-1">Kategori 1</div>
        <h2 className="font-display text-3xl font-semibold">Doğrudan Sera Gazı Salımları</h2>
        <p className="text-muted-foreground mt-1 text-sm max-w-2xl">
          Kuruluş sınırları içindeki sabit yanma (kazan, soba), hareketli yanma (araç, jeneratör) ve
          soğutucu gaz kaçakları.
        </p>
      </div>

      <SectionCard title="Sabit Yanma (Isıtma / Proses Yakıtları)" total={results?.sabit_total}>
        <TableHeader />
        {factors.sabit_yanma.map((f) => (
          <Row key={f.id} factor={f}
               value={data.sabit_yanma?.[f.id] || ""}
               onChange={(v) => setNumber("sabit_yanma", f.id, v)}
               result={results?.sabit_yanma?.find((x) => x.key === f.id)?.total} />
        ))}
      </SectionCard>

      <SectionCard title="Hareketli Yanma (Araçlar & Ekipmanlar)" total={results?.hareketli_total}>
        <TableHeader />
        {factors.hareketli_yanma.map((f) => (
          <Row key={f.id} factor={f}
               value={data.hareketli_yanma?.[f.id] || ""}
               onChange={(v) => setNumber("hareketli_yanma", f.id, v)}
               result={results?.hareketli_yanma?.find((x) => x.key === f.id)?.total} />
        ))}
      </SectionCard>

      <SectionCard title="Kaçak Emisyonlar (Soğutucu Gazlar, Yangın Söndürücüler)" total={results?.kacak_total}>
        <div className="text-xs text-muted-foreground mb-3 px-1">
          Her gaz için bir yıl boyunca kaçan miktarı <strong>kg</strong> cinsinden girin. Ekipman adı isteğe bağlıdır.
        </div>
        <div className="grid grid-cols-12 gap-2 text-[11px] uppercase tracking-wider text-muted-foreground px-1 pb-2">
          <div className="col-span-4">Gaz / Madde</div>
          <div className="col-span-3">Ekipman Adı (Opsiyonel)</div>
          <div className="col-span-2">Miktar (kg)</div>
          <div className="col-span-1 text-center">GWP</div>
          <div className="col-span-2 text-right">tCO₂e</div>
        </div>
        {factors.kacak.map((f) => {
          const item = data.kacak?.[f.id] || {};
          const res = results?.kacak?.find((x) => x.key === f.id)?.total || 0;
          return (
            <div key={f.id} className="grid grid-cols-12 gap-2 items-center py-1.5 border-t border-border/50">
              <div className="col-span-4 font-medium text-sm">{f.label}</div>
              <div className="col-span-3">
                <Input value={item.custom_label || ""} onChange={(e) => setKacakLabel(f.id, e.target.value)}
                       placeholder="örn. Lobi Klima" className="h-9" data-testid={`kacak-label-${f.id}`} />
              </div>
              <div className="col-span-2">
                <Input type="number" step="0.001" value={item.kg || ""}
                       onChange={(e) => setKacakKg(f.id, e.target.value)}
                       placeholder="0" className="h-9" data-testid={`kacak-kg-${f.id}`} />
              </div>
              <div className="col-span-1 text-xs text-muted-foreground text-center">{fmt(f.gwp, 0)}</div>
              <div className="col-span-2 text-right text-sm font-medium tabular-nums">
                {res > 0 ? fmt(res, 3) : "—"}
              </div>
            </div>
          );
        })}
      </SectionCard>
    </div>
  );
}

function TableHeader() {
  return (
    <div className="grid grid-cols-12 gap-2 text-[11px] uppercase tracking-wider text-muted-foreground px-1 pb-2">
      <div className="col-span-6">Kaynak</div>
      <div className="col-span-2">Faaliyet Verisi</div>
      <div className="col-span-2 text-center">EF (kg/birim)</div>
      <div className="col-span-2 text-right">tCO₂e</div>
    </div>
  );
}

function Row({ factor, value, onChange, result }) {
  return (
    <div className="grid grid-cols-12 gap-2 items-center py-1.5 border-t border-border/50">
      <div className="col-span-6">
        <div className="font-medium text-sm">{factor.label}</div>
        <div className="text-[11px] text-muted-foreground">{factor.kaynak}</div>
      </div>
      <div className="col-span-2">
        <Input type="number" step="any" value={value} onChange={(e) => onChange(e.target.value)}
               placeholder={`0 ${factor.unit}`} className="h-9" data-testid={`input-${factor.id}`} />
      </div>
      <div className="col-span-2 text-xs text-muted-foreground text-center tabular-nums">{fmt(factor.ef, 5)}</div>
      <div className="col-span-2 text-right text-sm font-medium tabular-nums">
        {(result || 0) > 0 ? fmt(result, 3) : "—"}
      </div>
    </div>
  );
}
